var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasicTrashFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ji5sqkuzca",
    d: "M0 0H32V32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-692.000000, -252.000000) translate(292.000000, 232.000000) translate(400.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jo28mm46gb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ji5sqkuzca"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E1D31",
    d: "M12 2.667c-1.47 0-2.667 1.196-2.667 2.666v1.334H4v2.666h2.667v17.334c0 1.47 1.196 2.666 2.666 2.666h13.334c1.47 0 2.666-1.196 2.666-2.666V9.333H28V6.667h-5.333V5.333c0-1.47-1.196-2.666-2.667-2.666h-8zm8 2.666v1.334h-8V5.333h8zM9.333 26.667V9.333h13.334v17.334H9.333zM14.667 12v12H12V12h2.667zM20 12v12h-2.667V12H20z",
    mask: "url(#jo28mm46gb)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicTrashFull);
export default __webpack_public_path__ + "static/media/basic-trash-full.4550ad0c.svg";
export { ForwardRef as ReactComponent };